// frontend/src/components/AccessError.js
import React from 'react';

const AccessError = ({ type = 'invalid' }) => {
  const errorConfig = {
    invalid: {
      title: 'Invalid Access Code',
      message: 'The link you\'re trying to access is invalid or has expired. Please check the URL or contact your team administrator for the correct link.',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      )
    },
    notfound: {
      title: 'Team Not Found',
      message: 'The team you\'re looking for doesn\'t exist or has been removed. Please verify the link with your team administrator.',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      )
    },
    expired: {
      title: 'Link Expired',
      message: 'This access link has expired. Please contact your team administrator for a new link.',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      )
    }
  };

  const config = errorConfig[type] || errorConfig.invalid;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <div className="mb-4">
          <svg 
            className="w-16 h-16 text-red-500 mx-auto" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            {config.icon}
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          {config.title}
        </h2>
        <p className="text-gray-600 mb-6">
          {config.message}
        </p>

      </div>
    </div>
  );
};

export default AccessError;